import _ from 'lodash'
import moment from 'moment'
import { sprintf } from 'sprintf-js'
import { FIREBASE_POS_CLIENT_REF, FIREBASE_POS_NOTIFY_REF, FIREBASE_POS_ORDER_REF, FIREBASE_POS_QUEUE_REF, FIREBASE_STOCK_REF } from './enum'
import langJson from '../lang/th.json'

export const getDateStart = (date) => {
  return `${moment(date).format('YYYY-MM-DD')}T00:00:00.000`
}

export const getDateEnd = (date) => {
  return `${moment(date).format('YYYY-MM-DD')}T23:59:59.999`
}

export const getLastSevenDay = () => {
  var startOfThisDay = moment().startOf('day')
  return {
    START: moment(startOfThisDay).subtract(6, 'day').toDate(),
    END: moment().endOf('day').toDate(),
  }
}

export const digValueInObject = (key = '', object) => {
  let text
  if (key.search('.') >= 0) {
    let props = key.split('.')
    for (const i in props) {
      if (!text) {
        text = object[props[i]]
      } else {
        text = text[props[i]]
      }
    }
  } else {
    text = object[key]
  }
  return text
}

export const toISODateString = (date = null) => {
  if (!date) return null
  return new Date(date).toISOString()
}

export const toDate = (date = null) => {
  if (!date) return null
  return new Date(date)
}

export const getDiffDate = (start, end, type) => {
  const a = moment(getDateEnd(end))
  const b = moment(getDateStart(start))
  const diff = a.diff(b, type, true)
  return Math.round(diff)
}

export const toNumber = (val) => {
  if (val === undefined || val === null) {
    return 0
  } else {
    return Number(val)
  }
}

export const getIsBarcode = (barcode) => {
  return barcode.length >= 5 && barcode.length <= 15
}

export const getMasterDataText = (name, $t) => {
  if (['{cash}', 'cash'].includes(name)) {
    return $t('apps.pos.message.cash')
  }
  else if (['{card}', 'card'].includes(name)) {
    return $t('apps.pos.message.card')
  }
  else if (['{qrcode}', 'qrcode'].includes(name)) {
    return $t('apps.pos.message.qrcode')
  }
  else if (['{promptpay}', 'promptpay'].includes(name)) {
    return $t('apps.pos.message.promptpay')
  }
  else if (['{dine_in}', 'dine_in'].includes(name)) {
    return $t('apps.pos.message.dine_in')
  }
  else if (['{take_away}', 'take_away'].includes(name)) {
    return $t('apps.pos.message.take_away')
  }
  else if (['{delivery}', 'delivery'].includes(name)) {
    return $t('apps.pos.message.delivery')
  }
  else if (['{self_pick_up}', 'self_pick_up'].includes(name)) {
    return $t('apps.pos.message.self_pick_up')
  }
  else if (['{menu_online}', 'menu_online'].includes(name)) {
    return $t('apps.pos.message.menuonline')
  }
  else if (['{call}', 'call'].includes(name)) {
    return $t('message.call')
  }
  else if (['{email}', 'email'].includes(name)) {
    return $t('message.email')
  }
  else if (['{VAT_EXC}'].includes(name)) {
    return $t('apps.product.message.vatexc')
  }
  else if (['{VAT_INC}'].includes(name)) {
    return $t('apps.product.message.vatinc')
  }
  else if (['{WHT_T}'].includes(name)) {
    return $t('apps.product.message.wht_t')
  }
  else if (['{WHT_A}'].includes(name)) {
    return $t('apps.product.message.wht_a')
  }
  else if (['{WHT_S}'].includes(name)) {
    return $t('apps.product.message.wht_s')
  }
  else if (['{WHT_R}'].includes(name)) {
    return $t('apps.product.message.wht_r')
  }
  else if (['{WHT_P_T}'].includes(name)) {
    return $t('apps.product.message.wht_p_t')
  }
  else if (['{WHT_P_A}'].includes(name)) {
    return $t('apps.product.message.wht_p_a')
  }
  else if (['{WHT_P_S}'].includes(name)) {
    return $t('apps.product.message.wht_p_s')
  }
  else if (['{WHT_P_R}'].includes(name)) {
    return $t('apps.product.message.wht_p_r')
  }
  else if (['{WHT_C_T}'].includes(name)) {
    return $t('apps.product.message.wht_c_t')
  }
  else if (['{WHT_C_A}'].includes(name)) {
    return $t('apps.product.message.wht_c_a')
  }
  else if (['{WHT_C_S}'].includes(name)) {
    return $t('apps.product.message.wht_c_s')
  }
  else if (['{WHT_C_R}'].includes(name)) {
    return $t('apps.product.message.wht_c_r')
  }
  else if (['{table}'].includes(name)) {
    return $t('apps.pos.label.table')
  }
  else if (`${name}`.search('{coa_') >= 0) {
    const keys = Object.keys(langJson.apps.accounting.coa)
    for (const key of keys) {
      if (`{${key}}` == name) {
        return $t(`apps.accounting.coa.${key}`)
      }
    }
  }
  else if (`${name}`.search('{exp_') >= 0) {
    const keys = Object.keys(langJson.apps.expenses.types)
    for (const key of keys) {
      if (`{${key}}` == name) {
        return $t(`apps.expenses.types.${key}`)
      }
    }
  }
  else if (`${name}`.search('{so_') >= 0) {
    const keys = Object.keys(langJson.apps.sales.types)
    for (const key of keys) {
      if (`{${key}}` == name) {
        return $t(`apps.sales.types.${key}`)
      }
    }
  }
  else if (`${name}`.search('{po_') >= 0) {
    const keys = Object.keys(langJson.apps.purchases.types)
    for (const key of keys) {
      if (`{${key}}` == name) {
        return $t(`apps.purchases.types.${key}`)
      }
    }
  }
  else if (`${name}`.search('{auto_open_entry_') >= 0) {
    const keys = Object.keys(langJson.apps.accounting.auto_entry)
    for (const key of keys) {
      if (`{${key}}` == name) {
        return $t(`apps.accounting.auto_entry.${key}`)
      }
    }
  }
  else if (['{journal_general}'].includes(name)) {
    return $t('apps.accounting.journal_types.general')
  }
  else if (['{journal_sale}'].includes(name)) {
    return $t('apps.accounting.journal_types.sale')
  }
  else if (['{journal_purchase}'].includes(name)) {
    return $t('apps.accounting.journal_types.purchase')
  }
  else if (['{journal_expense}'].includes(name)) {
    return $t('apps.accounting.journal_types.expense')
  }
  else if (['{journal_payroll}'].includes(name)) {
    return $t('apps.accounting.journal_types.payroll')
  }
  else if (['{journal_receive}'].includes(name)) {
    return $t('apps.accounting.journal_types.receive')
  }
  else if (['{journal_pay}'].includes(name)) {
    return $t('apps.accounting.journal_types.pay')
  }
  else if (['{journal_close_entry}'].includes(name)) {
    return $t('apps.accounting.journal_types.close_entry')
  }
  else {
    return name
  }
}

export const getMasterData = (name) => {
  const matches = `${name}`.match(/{(.*?)}/)
  if (matches) {
    return {
      name: matches[1],
      isCode: true,
    }
  }
  else {
    return {
      name,
      isCode: false,
    }
  }
}

export const getMasterDataTextWithRegex = (name, $t) => {
  const matches = `${name}`.match(/({.*?})/)
  if (matches) {
    return name.replace(matches[1], getMasterDataText(matches[1], $t))
  }
  else {
    return getMasterDataText(name, $t)
  }
}

export const delay = (ms) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, ms)
  })
}

// ใช้กับแอพขายหน้าร้าน เพื่อตัดสต๊อกจากพื้นที่จัดเก็บที่มีจำนวนคงเหลือเยอะสุดก่อน
export const getDefaultBinLocationId = (stockLocations) => {
  var stockLocations = _.cloneDeep(stockLocations.filter((v) => v.bin_location_id != null))
  if (stockLocations.length) {
    const sorted = stockLocations.sort((a, b) => b.instock - a.instock)
    if (sorted[0].instock > 0) {
      return sorted[0].bin_location_id
    }
  }
  return null
}

export const filterTaxesForSale = (taxes) => {
  return taxes.filter((tax) => tax.is_for_sale === true && tax.is_active === true)
}

export const getDisplayTaxNameRate = (taxName, taxRate) => {
  return `${taxName} ${Math.abs(taxRate)}%`
}

export const getQueuePath = (shopId, branchId, psId) => {
  return sprintf(FIREBASE_POS_QUEUE_REF, shopId, branchId, psId)
}

export const getQueueFullPath = (shopId, branchId, psId, queueNumber) => {
  return `${sprintf(FIREBASE_POS_QUEUE_REF, shopId, branchId, psId)}/queue_number-${queueNumber}`
}

export const getOrderPath = (shopId, branchId, psId) => {
  return sprintf(FIREBASE_POS_ORDER_REF, shopId, branchId, psId)
}

export const getOrderFullPath = (shopId, branchId, psId, queueNumber, orderId) => {
  return `${sprintf(FIREBASE_POS_ORDER_REF, shopId, branchId, psId)}/queue_number-${queueNumber}/order_id-${orderId}`
}

export const getNotifyPath = (shopId, branchId, psId) => {
  return sprintf(FIREBASE_POS_NOTIFY_REF, shopId, branchId, psId)
}

export const getNotifyFullPath = (shopId, branchId, psId, queueNumber, notifyId) => {
  return `${sprintf(FIREBASE_POS_NOTIFY_REF, shopId, branchId, psId)}/queue_number-${queueNumber}/notify_id-${notifyId}`
}

export const getClientFullPath = (shopId, branchId, psId, clientId) => {
  return `${sprintf(FIREBASE_POS_CLIENT_REF, shopId, branchId, psId)}/client_id-${clientId}`
}

export const getStockPath = (shopId) => {
  return `${sprintf(FIREBASE_STOCK_REF, shopId)}`
}

export function flattenChartOfAccounts (chartOfAccounts, shopId) {
  const flatList = []

  function traverse (accounts, level = 1, parentIndex = 0, parentAccountCode = null, parentAccountType = null, nodeType = 'account') {
    accounts.forEach((account, idx, arr) => {
      const {
        children, ...rest
      } = account
      const newIndex = parentIndex * 10 + (idx + 1)
      const isLastNode = idx === arr.length - 1
      const newItem = {
        ...rest,
        type: nodeType,
        account_type: account.account_type || parentAccountType,
        index: newIndex,
        parent_account_code: parentAccountCode,
        level: level,
        is_last_node: isLastNode,
        open: false,
      }

      if (children.length == 0 && account.is_group && account.type != 'action') {
        const nodeType = 'action'
        const actionChildren = [
          {
            type: nodeType,
            parent_account_code: parentAccountCode,
            children: [],
          },
        ]
        traverse(actionChildren, level + 1, newIndex, account.account_code, account.account_type || parentAccountType, nodeType)
      }

      if (account.is_active) {
        flatList.push(newItem)
      }

      if (isLastNode && level > 1 && account.type != 'action') {
        flatList.push({
          type: 'action',
          parent_account_code: parentAccountCode,
          level: level,
          children: [],
        })
      }

      if (children) {
        traverse(children, level + 1, newIndex, account.account_code, account.account_type || parentAccountType, nodeType)
      }
    })
  }

  traverse(chartOfAccounts)
  return flatList
}

export function buildTree (data) {
  const tree = []
  const nodes = {}
  const childrenMap = {}

  // Step 1: Create a mapping of account_code to nodes and a children map
  data.forEach((item) => {
    const node = {
      ...item,
      children: [],
    }
    nodes[item.account_code] = node
    if (item.parent_account_code !== null) {
      if (!childrenMap[item.parent_account_code]) {
        childrenMap[item.parent_account_code] = []
      }
      childrenMap[item.parent_account_code].push(node)
    } else {
      tree.push(node)
    }
  })

  // Step 2: Assign children to their parent nodes
  Object.keys(childrenMap).forEach((parentCode) => {
    if (nodes[parentCode]) {
      nodes[parentCode].children = childrenMap[parentCode]
    }
  })

  return tree
}

export function setOpenedAccounts(chartOfAccounts, accountCode) {
  function findAndAdd(accounts) {
    for (let account of accounts) {
      if (account.account_code == accountCode) {
        account.open = true
        return true
      }
      if (account.children) {
        if (findAndAdd(account.children)) return true
      }
    }
    return false
  }

  findAndAdd(chartOfAccounts)
}

export function splitBracedString(value) {
  return value.match(/\{.*?\}|\s*·\s*.*$/g) || [value]
}

export const getTotalPrice = (price, discountPercentage) => (currency) => {
  const discountAmount = (price * discountPercentage) / 100
  const totalPrice = price - discountAmount
  return getTotalByCurency(totalPrice, currency)
}

export const getDiscountAmount = (price, discountPercentage) => (currency) => {
  const discountAmount = (price * discountPercentage) / 100
  return getTotalByCurency(discountAmount, currency)
}

export const getTotalByCurency = (total, currency) => {
  if (currency === 'thb') {
    return Math.round(total)
  } else {
    return total
  }
}



// WEBPACK FOOTER //
// ./src/helpers/index.js